module.exports = {
    initialValues: {
        currentInfo: {
            jobSituation: '',
            contractType: '',
            jobIncorporationDate: {
                month: '',
                year: ''
            },
            studyLevel: ''
        },
        ceaCode: {
            idCea: '',
            dateGenCea: {
                day: '',
                month: '',
                year: ''
            },
            inputsCode: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: ''
            }
        }
    },
    showErrorCeaCode: {
        ceaCode: {
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false
        },
        idCea: false,
        dateGenCea: {
            day: false,
            month: false,
            year: false
        }
    }
}
